<div class="tw-relative tw-pt-8 tw-pb-8">
  <div class="tw-absolute tw-top-3 tw-right-3 tw-w-8 tw-h-8 tw-rounded-full tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-cursor-pointer" (click)="closeBottomSheet()">
    <img class="tw-w-6 tw-h-6" src="/assets/icons/close-icon-bottomsheet.png" alt="close" />
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-8">
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-5">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-w-[312px]">
        <p class="tw-font-lexend tw-font-bold tw-text-[24px] tw-leading-[25px] tw-text-black tw-text-center tw-capitalize" i18n="@@sharePaymentLinkTitle">Share Payment Link</p>
        <div class="tw-w-[148px] tw-h-[1px]" [class]="acqRebranding2025 ? 'tw-bg-teal-600' : 'tw-bg-green-400'"></div>
      </div>

      <div class="tw-w-[312px]">
        <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[18px] tw-text-gray-500 tw-mb-4" i18n="@@howItWorks">How it works:</p>

        <div>
          <div class="tw-flex tw-items-start tw-gap-4">
            @if (acqRebranding2025) {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/teal-green-bottomsheet-share.png" alt="share" />
            } @else {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/light-green-bottomsheet-share.png" alt="share" />
            }
            <div>
              <p class="tw-font-body tw-font-bold tw-text-[14px] tw-leading-[18px] tw-text-black" i18n="@@shareLinkWithAnyone">Share link with anyone</p>
              <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500" i18n="@@sendViaWhatsapp">Send via Whatsapp, SMS, email or any app.</p>
            </div>
          </div>

          <div class="tw-w-[2px] tw-h-[39px] tw-ml-[17px]" [class]="acqRebranding2025 ? 'tw-bg-teal-100' : 'tw-bg-green-100'"></div>

          <div class="tw-flex tw-items-start tw-gap-4">
            @if (acqRebranding2025) {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/teal-green-bottomsheet-people.png" alt="people" />
            } @else {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/light-green-bottomsheet-people.png" alt="people" />
            }
            <div>
              <p class="tw-font-body tw-font-bold tw-text-[14px] tw-leading-[18px] tw-text-black" i18n="@@theyPayForYou">They pay for you</p>
              <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500" i18n="@@theyOpenTheLink">They open the link and complete the payment.</p>
            </div>
          </div>

          <div class="tw-w-[2px] tw-h-[39px] tw-ml-[17px]" [class]="acqRebranding2025 ? 'tw-bg-teal-100' : 'tw-bg-green-100'"></div>

          <div class="tw-flex tw-items-start tw-gap-4">
            @if (acqRebranding2025) {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/teal-green-bottomsheet-tick.png" alt="tick" />
            } @else {
              <img class="tw-w-9 tw-h-9 tw-flex-shrink-0" src="/assets/icons/light-green-bottomsheet-tick.png" alt="tick" />
            }
            <div>
              <p class="tw-font-body tw-font-bold tw-text-[14px] tw-leading-[18px] tw-text-black" i18n="@@orderGetsPlaced">Order gets placed</p>
              <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500" i18n="@@confirmationOnApp">You'll get a confirmation on the Cureskin app once payment is done.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
      @if (isCCODEligible) {
        @if (acqRebranding2025) {
          <button csButton
                  type="button"
                  class="tw-w-[312px]"
                  style="border-radius: 12px !important;"
                  (click)="onCtaClick()"
                  i18n="@@generateAndShareLink"
          >Generate & share link</button>
        } @else {
          <cs-button [class]="'primary w100 shine'" (callback)="onCtaClick()">
            <cs-button-text class="tw-font-body" i18n="@@generateAndShareLink">Generate & share link</cs-button-text>
          </cs-button>
        }
      } @else {
        @if (acqRebranding2025) {
          <button csButton
                  type="button"
                  class="tw-w-[312px]"
                  style="border-radius: 12px !important;"
                  (click)="onCtaClick()"
                  i18n="@@sharePaymentLinkWithAmount"
          >Share ₹{{orderSP | number}} payment link</button>
        } @else {
          <cs-button [class]="'primary w100 shine'" (callback)="onCtaClick()">
            <cs-button-text class="tw-font-body" i18n="@@sharePaymentLinkWithAmount">Share ₹{{orderSP | number}} payment link</cs-button-text>
          </cs-button>
        }
      }
      <p class="tw-font-lexend tw-font-normal tw-text-[12px] tw-leading-[18px] tw-text-gray-500 tw-text-center" i18n="@@paymentLinkExpires">Payment link expires in 24 hours.</p>
    </div>
  </div>
</div>
